import { render, staticRenderFns } from "./FaqOverview.vue?vue&type=template&id=146cd49a&scoped=true&"
import script from "./FaqOverview.vue?vue&type=script&lang=js&"
export * from "./FaqOverview.vue?vue&type=script&lang=js&"
import style0 from "./FaqOverview.vue?vue&type=style&index=0&id=146cd49a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146cd49a",
  null
  
)

export default component.exports